/**
 *
 * BigSelector
 *
 */
import * as React from 'react';
import { useMedia } from 'use-media';
// import styled from 'styles/styled-components';

interface Props {
  title?: string;
  children: React.ReactNode;
  diviser?: boolean;
}

function SectionOptions(props: Props) {
  const isMobile = useMedia({ maxWidth: 1023 });
  return (
    <>
      <div className="section flex flex-col">
        {props.title && !isMobile && (
          <div className="self-center text-sm text-gray400">{props.title}</div>
        )}
        <div className="flex justify-center">{props.children}</div>
      </div>
      {props.diviser && (
        <div className="diviser border-r border-grey h-20  mx-2 self-center" />
      )}
    </>
  );
}

export default SectionOptions;
